export const handleCallback = (callback) => {
    return async (data) => {
      try {
         return await callback(data);
      } catch (error) {
        console.error("error",error)
       return ({ 
        error:error,
          Success :false,
          data : [],
          msg  : `${'From user' + error.toString()}`
      } )
      }
    };
  };